import { createCtxMenuConfig, MenuItemType } from '@antv/xflow';
import { IconStore, XFlowNodeCommands, XFlowEdgeCommands } from '@antv/xflow';
import { DeleteOutlined, EditOutlined, StopOutlined } from '@ant-design/icons';
/** 节点命令 */
export let CustomCommands;
(function (CustomCommands) {
    const category = '节点操作';
    /** 清除画布 */
    CustomCommands.CLEAR_GRAPH = {
        id: 'xflow:clear-graph',
        label: 'Clear Graph',
        category,
    };
    /** 导出 */
    CustomCommands.EXPORT_GRAPH = {
        id: 'xflow:export-graph',
        label: 'Export Graph',
        category,
    };
    /** 重命名节点弹窗 */
    CustomCommands.SHOW_RENAME_MODAL = {
        id: 'xflow:rename-node-modal',
        label: 'Rename Modal',
        category,
    };
})(CustomCommands || (CustomCommands = {}));
export let NsRenameNodeCmd;
(function (NsRenameNodeCmd) {
    /** Command: 用于注册named factory */
    NsRenameNodeCmd.command = CustomCommands.SHOW_RENAME_MODAL;
    /** hook name */
    NsRenameNodeCmd.hookKey = 'renameNode';
})(NsRenameNodeCmd || (NsRenameNodeCmd = {}));
/** menuitem 配置 */
export let NsMenuItemConfig;
(function (NsMenuItemConfig) {
    /** 注册菜单依赖的icon */
    IconStore.set('DeleteOutlined', DeleteOutlined);
    IconStore.set('EditOutlined', EditOutlined);
    IconStore.set('StopOutlined', StopOutlined);
    NsMenuItemConfig.DELETE_EDGE = {
        id: XFlowEdgeCommands.DEL_EDGE.id,
        label: 'Delete Edge',
        iconName: 'DeleteOutlined',
        onClick: async ({ target, commandService }) => {
            commandService.executeCommand(XFlowEdgeCommands.DEL_EDGE.id, {
                edgeConfig: target.data,
            });
        },
    };
    NsMenuItemConfig.DELETE_NODE = {
        id: XFlowNodeCommands.DEL_NODE.id,
        label: 'Delete Node',
        iconName: 'DeleteOutlined',
        onClick: async ({ target, commandService }) => {
            commandService.executeCommand(XFlowNodeCommands.DEL_NODE.id, {
                nodeConfig: { id: target.data.id },
            });
        },
    };
    NsMenuItemConfig.EMPTY_MENU = {
        id: 'EMPTY_MENU_ITEM',
        label: 'Empty Menu',
        isEnabled: false,
        iconName: 'DeleteOutlined',
    };
    NsMenuItemConfig.SEPARATOR = {
        id: 'separator',
        type: MenuItemType.Separator,
    };
})(NsMenuItemConfig || (NsMenuItemConfig = {}));

export const useMenuConfig = createCtxMenuConfig((config) => {
    config.setMenuModelService(
        async (target, model, modelService, toDispose) => {
            const { type } = target;
            switch (type) {
                /** 节点菜单 */
                case 'node':
                    model.setValue({
                        id: 'root',
                        type: MenuItemType.Root,
                        submenu: [NsMenuItemConfig.DELETE_NODE],
                    });
                    break;
                /** 边菜单 */
                case 'edge':
                    model.setValue({
                        id: 'root',
                        type: MenuItemType.Root,
                        submenu: [NsMenuItemConfig.DELETE_EDGE],
                    });
                    break;
                /** 画布菜单 */
                case 'blank':
                    model.setValue({
                        id: 'root',
                        type: MenuItemType.Root,
                        submenu: [NsMenuItemConfig.EMPTY_MENU],
                    });
                    break;
                /** 默认菜单 */
                default:
                    model.setValue({
                        id: 'root',
                        type: MenuItemType.Root,
                        submenu: [NsMenuItemConfig.EMPTY_MENU],
                    });
                    break;
            }
        }
    );
});
